module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133240-1980452879.7d53320b.jpg";